import React, {useState} from "react";
import PropTypes from "prop-types";
//import TransparentButton from "../../shared/button/transparent-button";
import InputRadioButton from "../../shared/input-radio-button";
import styles from "./styles.css";
import Filters from "../../../utils/filters-v2";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { DEFAULT_CITY } from "../../../constants/app-constants";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import useModifiedFilters from "../../../hooks/use-modified-filters";

const SortBy = ({
    sortIds,
    sortData,
    updateSelectedSortConnect,
    selectedCity,
    urlOptions,
    updateUrlOptionsConnect,
    allFilters,
    history,
    onToggleSort,
    reloadCarListConnect,
    selectedSort,
    showFilterPageRevamp,
    selectedFilters,
    replaceSelectedFilterConnect
}) => {

    const { getModifiedFilters } = useModifiedFilters();

    const [selectedSortOption, setSelectedSortOption] = useState(selectedSort);
    const modifiedFilter =  getModifiedFilters(selectedFilters);

    const onApplySort = (sort, modifiedUrlObj) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {eventAction: "sort_applied", eventLabel: "sort applied"});
        updateSelectedSortConnect(sort);
        replaceSelectedFilterConnect(modifiedFilter);
        const filters = new Filters({cityCode: selectedCity.code || DEFAULT_CITY.AU.code});
        const {relativeURL} = filters.getListingPayload({
            selectedFilters: modifiedFilter,
            filters: allFilters,
            options: modifiedUrlObj
        });
        onToggleSort();
        reloadCarListConnect(true);
        history.replace(relativeURL);
    };

    const onChangeSort = (displayText, labelName, e) => {
        const sortObj = { key: e.target.value, displayText };
        const modifiedUrlObj = { ...(urlOptions || {}), sort: sortObj.key};
        setSelectedSortOption(sortObj);
        updateUrlOptionsConnect(modifiedUrlObj);
        onApplySort(sortObj, modifiedUrlObj);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_SORT_ATTRIBUTE_SELECTED_SELECTED, {
            eventLabel: `options ${labelName}/${displayText}`
        });
    };

    return (
        <React.Fragment>
            <div className="filter-section" styleName={`styles.wrapper ${showFilterPageRevamp ? "styles.wrapperClp" : ""}`}>
                {
                    (sortIds || []).sort().map((id) => (
                        <div key={id} styleName={"styles.sortByRow"}>
                            {sortData[id].name && <h3 styleName={"styles.heading"}>{sortData[id].name}</h3>}
                            <ul styleName={"styles.sortBy"}>
                                {
                                    sortData[id].options.map((sortOption, index) => (
                                        <li key={index}>
                                            <InputRadioButton
                                                onChange={onChangeSort.bind(null, sortOption.displayText, sortData[id].name)}
                                                checked={selectedSortOption.key === sortOption.key}
                                                id={sortOption.key}
                                                value={sortOption.key}
                                                text={sortOption.displayText} />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    ))
                }
                {/*<div styleName={"styles.buttonWrap"}>
                    <TransparentButton onClick={onApplySort} text={"APPLY"} />
                </div>*/}
            </div>
        </React.Fragment>
    );
};

SortBy.propTypes = {
    sortIds: PropTypes.array,
    sortData: PropTypes.object,
    updateSelectedSortConnect: PropTypes.func,
    selectedCity: PropTypes.object,
    urlOptions: PropTypes.object,
    updateUrlOptionsConnect: PropTypes.func,
    allFilters: PropTypes.object,
    history: PropTypes.object,
    onToggleSort: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    selectedSort: PropTypes.object,
    showFilterPageRevamp: PropTypes.bool,
    selectedFilters: PropTypes.array,
    replaceSelectedFilterConnect: PropTypes.array
};

export default SortBy;
